import MapChart from './MapChart'

export default MapChart



// WEBPACK FOOTER //
// ./src/modules/Charts/Map/MapChart/index.js